import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { WebViewParamsService } from '@core/services/webview-params.service';

export const routes: Routes = [
  {
    path: 'start-shift',
    loadChildren: () =>
      import('./features/start-shift/start-shift.routes').then(
        (m) => m.START_SHIFT_ROUTES,
      ),
  },
  {
    path: 'finish-shift',
    loadChildren: () =>
      import('./features/finish-shift/finish-shift.routes').then(
        (m) => m.FINISH_SHIFT_ROUTES,
      ),
  },
  {
    path: 'cabinet',
    loadChildren: () =>
      import('./features/cabinet/cabinet.routes').then(
        (m) => m.CABINET_ROUTES,
      ),
  },
  {
    path: '**',
    redirectTo: () =>
      inject(WebViewParamsService).isFinishWorking() ? 'finish-shift' : 'start-shift',
  },
];
